// Spinner.js
import React from 'react';

const Spinner = ({ title='', color, size='50px', thick='10px' }) => {
  const spinnerStyle = {
    display: 'inline-block',
    width: size,
    height: size,
    border: `${thick} solid rgba(0, 0, 0, 0.1)`,
    borderRadius: '50%',
    borderTopColor: color,
    animation: 'spin 1s ease-in-out infinite'
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  };

  const titleStyle = {
    marginBottom: '20px',
    fontSize: '20px',
    fontWeight: 'bold'
  };

  return (
    <div style={containerStyle}>
      {title && <div style={titleStyle}>{title}</div>}
      <div style={spinnerStyle}></div>
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Spinner;
